module.exports = __webpack_public_path__ + "images/pages/how-prolaryn/prolaryn-plus.png";